export const colorLinkType = {
  KANBAN: 'KANBAN',
  FLAMSTOP_TASKRESOURCEPLANNER: 'FLAMSTOP_TASKRESOURCEPLANNER',
};
